import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { u as useSafeLayoutEffect_1 } from './useSafeLayoutEffect-7WC_06jN.js';
import { F as FormField } from './FormField-BneBLurL.js';

function InputTextInternal(props, ref) {
    const inputRef = useRef(null);
    const actionsRef = useRef(null);
    const wrapperRef = useRef(null);
    const rowRange = getRowRange();
    useImperativeHandle(ref, () => ({
        insert: (text) => {
            insertText(text);
        },
        blur: () => {
            const input = inputRef.current;
            if (input) {
                input.blur();
            }
        },
        focus: () => {
            const input = inputRef.current;
            if (input) {
                input.focus();
            }
        },
        scrollIntoView: arg => {
            const input = inputRef.current;
            if (input) {
                input.scrollIntoView(arg);
            }
        },
    }));
    useSafeLayoutEffect_1(() => {
        if (inputRef &&
            inputRef.current instanceof HTMLTextAreaElement &&
            wrapperRef &&
            wrapperRef.current instanceof HTMLDivElement) {
            resize(inputRef.current, wrapperRef.current);
        }
    }, [inputRef.current, wrapperRef.current]);
    return (React.createElement(FormField, Object.assign({}, props, { type: props.multiline ? "textarea" : "text", inputRef: inputRef, actionsRef: actionsRef, wrapperRef: wrapperRef, onChange: handleChange, rows: rowRange.min })));
    function handleChange(newValue) {
        props.onChange && props.onChange(newValue);
        if (inputRef &&
            inputRef.current instanceof HTMLTextAreaElement &&
            wrapperRef &&
            (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) instanceof HTMLDivElement) {
            resize(inputRef.current, wrapperRef.current);
        }
    }
    function getRowRange() {
        if (props.rows === undefined) {
            return { min: 3, max: 3 };
        }
        else if (typeof props.rows === "object") {
            return { min: props.rows.min, max: props.rows.max };
        }
        else {
            return { min: props.rows, max: props.rows };
        }
    }
    function resize(textArea, wrapper) {
        if (rowRange.min === rowRange.max)
            return;
        textArea.style.flexBasis = "auto";
        wrapper.style.height = "auto";
        textArea.style.flexBasis = textAreaHeight(textArea) + "px";
    }
    function textAreaHeight(textArea) {
        const { lineHeight, borderBottomWidth, borderTopWidth, paddingBottom, paddingTop, } = window.getComputedStyle(textArea);
        const maxHeight = rowRange.max * parseFloat(lineHeight) +
            parseFloat(borderTopWidth) +
            parseFloat(borderBottomWidth) +
            parseFloat(paddingTop) +
            parseFloat(paddingBottom);
        const scrollHeight = textArea.scrollHeight +
            parseFloat(borderTopWidth) +
            parseFloat(borderBottomWidth);
        return Math.min(scrollHeight, maxHeight);
    }
    function insertText(text) {
        var _a;
        const input = inputRef.current;
        if (input) {
            insertAtCursor(input, text);
            const newValue = input.value;
            (_a = actionsRef.current) === null || _a === void 0 ? void 0 : _a.setValue(newValue);
            props.onChange && props.onChange(newValue);
        }
    }
}
const InputText = forwardRef(InputTextInternal);
function insertAtCursor(input, newText) {
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const text = input.value;
    const before = text.substring(0, start);
    const after = text.substring(end, text.length);
    input.value = before + newText + after;
    input.selectionStart = input.selectionEnd = start + newText.length;
    input.focus();
}

export { InputText as I };
